/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Home_Compare_CtaInputs */

const en_pc_home_compare_cta = /** @type {(inputs: Pc_Home_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the full comparison`)
};

const zh_pc_home_compare_cta = /** @type {(inputs: Pc_Home_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看完整对比`)
};

/**
* | output |
* | --- |
* | "Read the full comparison" |
*
* @param {Pc_Home_Compare_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_home_compare_cta = /** @type {((inputs?: Pc_Home_Compare_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Home_Compare_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_home_compare_cta(inputs)
	return zh_pc_home_compare_cta(inputs)
});
export { pc_home_compare_cta as "pc.home_compare.cta" }